































import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import api from '@/api'
import targetCountryDefault from '@/assets/image/targetCountryDefault.png'

@Component
export default class CountryMobileWithSearch extends Vue {
    @Prop({default: 0}) value!: any

    @Prop({default: ''}) prefixValue!: any

    @Prop({default: null}) extendValue!: any

    @Prop({default: false}) disabled!: any

    @Prop({default: ''}) placeholder!: any

    @Prop({default: false}) isEmployer!: any

    @Prop({
        default() {
            return {}
        },
    }) country!: any

    loading:boolean = false

    supportCountryMap: any[] = []

    currCountry: any = {}

    prefix: string = ''

    mobile: string = ''

    getPrefix() {
        let country
        if (!this.value) {
            if (this.extendValue) {
                country = this.supportCountryMap.find(item => this.extendValue.startsWith(item.areaCode))
            } else {
                this.prefix =  '+65'
            }
        }
        if (this.value) {
            country = this.supportCountryMap.find(item => this.value.startsWith(item.areaCode))
        }
        this.prefix = country ? country.areaCode : '+65'
        if (this.prefixValue) {
            this.prefix = this.prefixValue
        }
    }

    getMobile() {
        if (!this.prefix || (this.value && !String(this.value).startsWith(this.prefix))) {
            this.mobile = this.value
        }
        this.mobile = this.value ? this.value.slice(this.prefix.length) : ''
    }

    getCurrCountry() {
        if (!this.prefix) {
            this.currCountry = {}
        }
        this.currCountry = this.supportCountryMap.find(item =>item.areaCode.startsWith(this.prefix)) || {}
    }

    @Watch('currCountry', {immediate: true})
    onCurrCountryChange(newVal) {
        this.prefix = newVal.areaCode
        this.$emit('update:country', newVal)
    }

    @Watch('prefix', {immediate: false})
    onPrefixChange(newVal) {
        this.$emit('input', newVal + this.mobile)
        this.getCurrCountry()
    }

    @Watch('mobile', {immediate: false})
    onMobileChange(newVal) {
        this.$emit('input', this.prefix + newVal.replace(/[^\d]/g, ''))
    }

    @Watch('value', {immediate: false})
    onValueChange() {
        this.getPrefix()
        this.getMobile()
    }

    created() {
        api.support_employerCountry_list_by_keyword().then(res=>{
            this.supportCountryMap = res.data || []
            this.supportCountryMap.map(item=>{
                item.areaCode = '+' + item.areaCode
            })
            this.getPrefix()
            this.getCurrCountry()
            this.getMobile()
        })
    }

    triggerFocus(){
        api.support_employerCountry_list_by_keyword().then(res => {
            this.supportCountryMap = res.data || []
            this.supportCountryMap.map(item=>{
                item.areaCode = '+' + item.areaCode
            })
        })
    }

    blurMobile() {
        this.$emit('blurMobile')
    }

    changeMobile(val) {
        val = val.replace(/[^\d]/g, '')
        this.$emit('changeMobile', this.prefix + val)
    }

    remoteMethod(keyword){
        this.loading = true
        api.support_employerCountry_list_by_keyword({keyword}).then(res => {
            this.supportCountryMap = res.data || []
            this.supportCountryMap.map(item=>{
                item.areaCode = '+' + item.areaCode
            })
        }).finally(()=>{
            this.loading = false
        })
    }

    removePlusSign(str) {
        if (str.startsWith("+")) {
            return str.substring(1);
        }
        return str;
    }

    setDefaultImage(countryName){
        var imgElement = document.getElementById(countryName);
        if (imgElement) {
            (imgElement as any).src = targetCountryDefault
        }
    }
}
